import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ProductCard.css';
import { useLanguage } from '../../../context/LanguageContext';

const ProductCard = ({ product }) => {
  const navigate = useNavigate();
  const { t, lang } = useLanguage();
  const [translatedData, setTranslatedData] = useState({});

  // KANKA OTOMATİK ÇEVİRİ MOTORU
  const translateText = async (text, targetLang) => {
    if (!text || targetLang === 'TR') return text;
    
    const cacheKey = `${text}_${targetLang}`;
    if (translatedData[cacheKey]) return translatedData[cacheKey];

    try {
      const response = await fetch(
        `https://translate.googleapis.com/translate_a/single?client=gtx&sl=tr&tl=${targetLang.toLowerCase()}&dt=t&q=${encodeURI(text)}`
      );
      const data = await response.json();
      const result = data[0][0][0];
      
      setTranslatedData(prev => ({ ...prev, [cacheKey]: result }));
      return result;
    } catch (error) {
      return text; 
    }
  };

  // Ürün verileri veya dil değiştikçe çevirileri tetikle
  useEffect(() => {
    if (lang !== 'TR' && product) {
      const fieldsToTranslate = [
        product.title,
        product.description,
        product.animalGroup,
        product.packaging,
        product.usageGuide
      ];
      fieldsToTranslate.forEach(field => translateText(field, lang));
    }
  }, [product, lang]);

  const getDisplay = (originalText) => {
    const cacheKey = `${originalText}_${lang}`;
    return translatedData[cacheKey] || originalText;
  };

  const handleDetailClick = () => {
    navigate(`/urun/${product.id}`);
  };

  const analysis = product.analysis || {};

  return (
    <div className="catalog-product-card" onClick={handleDetailClick}>
      <div className="card-image-area">
        <img 
          src={product.imageUrl || "/assets/placeholder-product.jpg"} 
          alt={getDisplay(product.title)} 
        />
      </div>

      <div className="card-info-content">
        <div className="title-section">
          {/* Başlık ve Açıklama Otomatik Çevriliyor */}
          <h3 className="card-main-title">{getDisplay(product.title)}</h3>
          <p className="card-sub-description">{getDisplay(product.description)}</p>
        </div>

        <div className="card-spec-wrapper">
          <div className="spec-row">
            <span className="spec-label">{t('catalog.productCard.animal')}</span>
            <span className="spec-val">{getDisplay(product.animalGroup)}</span>
          </div>
          <div className="spec-row">
            <span className="spec-label">{t('catalog.productCard.pkg')}</span>
            <span className="spec-val">{getDisplay(product.packaging)}</span>
          </div>
          <div className="spec-row">
            <span className="spec-label">{t('catalog.productCard.license')}</span>
            <span className="spec-val">{product.license}</span>
          </div>
          <div className="spec-row">
            <span className="spec-label">{t('catalog.productCard.barcode')}</span>
            <span className="spec-val">{product.barcode}</span>
          </div>
        </div>

        <div className="card-details-grid">
          <div className="detail-blue-box">
            <h4>{t('catalog.productCard.techTable')}</h4>
            <ul>
              {analysis.hamProtein && <li>{t('catalog.productCard.analysis1')}: %{analysis.hamProtein}</li>}
              {analysis.hamYag && <li>{t('catalog.productCard.analysis2')}: %{analysis.hamYag}</li>}
              {analysis.hamKul && <li>{t('catalog.productCard.analysis3')}: %{analysis.hamKul}</li>}
            </ul>
          </div>
          <div className="detail-blue-box">
            <h4>{t('catalog.productCard.guide')}</h4>
            <div className="guide-mini-text">
              {product.usageGuide 
                ? getDisplay(product.usageGuide).substring(0, 40) + "..." 
                : t('catalog.productCard.noData') || "N/A"}
            </div>
          </div>
        </div>

        <button className="card-footer-btn">
          {t('catalog.productCard.btn')} <span>→</span>
        </button>
      </div>
    </div>
  );
};

export default ProductCard;